import React from 'react';

export default function EmptySidebarIcon(): JSX.Element {
  return <div className="result-icon" />;
}
